import React from "react";
import PageHeader from "../../../../components/headers/PageHeader";
import castel from "../../../../assets/Images/castel.jpg";
import "./CDSCO.css";
import { Link } from "react-router-dom";
import Flag from "react-world-flags";

export default function CDSCO() {
    return (
        <div className="cdsco-page">
            <PageHeader
                mediaSrc={castel}
                mediaType="image"
                title="CDSCO Medical Device Registration"
                slogan=""
            />

            <section className="cdsco-section cdsco-introSection">
                <h2>CDSCO Regulatory Support for Medical Devices in India</h2>

                <p>
                    The Central Drugs Standard Control Organization regulates the import,
                    manufacture, sale, and distribution of medical devices and in-vitro
                    diagnostics in India. For companies entering or expanding within the
                    Indian medical device market, a structured regulatory pathway is
                    essential to avoid delays, documentation gaps, and compliance risks.
                </p>

                <p>
                    Eupraxia supports medical device companies, importers, manufacturers,
                    and global partners with end-to-end CDSCO regulatory assistance,
                    including classification review, license strategy, dossier preparation,
                    MD Online submission support, query response, renewals, and ongoing
                    regulatory lifecycle management.
                </p>
            </section>

            <section className="cdsco-section">
                <h2>India Medical Device Registration Pathway</h2>

                <p>
                    Medical device registration in India requires careful alignment with
                    device classification, intended use, risk category, manufacturing
                    location, import status, labeling requirements, and applicable technical
                    documentation. Our team helps convert regulatory requirements into a
                    clear submission plan with practical timelines and audit-ready
                    documentation.
                </p>
            </section>

            <section className="cdsco-section cdsco-servicesSection">
                <h2>Our CDSCO Services</h2>

                <p className="cdsco-sectionIntro">
                    We provide focused regulatory support across the major CDSCO approval
                    and licensing routes for medical devices and IVDs in India.
                </p>

                <div className="cdsco-cardGrid">
                    <article className="cdsco-card">
                        <h3>CDSCO MD Online Registration</h3>
                        <p>
                            Support for MD Online portal preparation, applicant account
                            coordination, documentation review, form selection, application
                            compilation, submission tracking, and authority query management.
                        </p>
                    </article>

                    <article className="cdsco-card">
                        <h3>CDSCO Certification</h3>
                        <p>
                            Assistance with regulatory certifications, product registration
                            documentation, compliance declarations, Free Sale Certificate
                            support, export-related documentation, and regulatory status
                            confirmation for Indian market access.
                        </p>
                    </article>

                    <article className="cdsco-card">
                        <h3>Manufacturing License Registration</h3>
                        <p>
                            Preparation and coordination for medical device manufacturing
                            licenses, including Device Master File, Plant Master File,
                            quality documentation, manufacturing site details, and submission
                            support for domestic manufacturers.
                        </p>
                    </article>

                    <article className="cdsco-card">
                        <h3>Import License Registration</h3>
                        <p>
                            End-to-end support for foreign manufacturers and Indian importers,
                            including Authorized Representative or Indian Agent coordination,
                            import license applications, product documentation, labeling
                            review, and CDSCO query response.
                        </p>
                    </article>

                    <article className="cdsco-card">
                        <h3>Wholesale License for Medical Devices</h3>
                        <p>
                            Regulatory guidance for wholesale license requirements, applicant
                            documentation, premises-related details, compliance checks, and
                            coordination for distribution of medical devices within India.
                        </p>
                    </article>
                </div>
            </section>

            <section className="cdsco-section cdsco-detailSection">
                <h2>How We Support Your Submission</h2>

                <div className="cdsco-infoGrid">
                    <article className="cdsco-infoBox">
                        <h3>Regulatory Classification</h3>
                        <p>
                            We help assess the device category, risk class, intended use,
                            applicable rules, and likely regulatory pathway before preparing
                            the application.
                        </p>
                    </article>

                    <article className="cdsco-infoBox">
                        <h3>Dossier Preparation</h3>
                        <p>
                            We compile and review technical documentation, product details,
                            quality certificates, manufacturing information, labeling, IFU,
                            and supporting regulatory evidence.
                        </p>
                    </article>

                    <article className="cdsco-infoBox">
                        <h3>Authority Coordination</h3>
                        <p>
                            We support application tracking, deficiency response, document
                            clarification, and coordination until the license, approval, or
                            certificate process is completed.
                        </p>
                    </article>
                </div>
            </section>

            <section className="cdsco-section cdsco-offerSection">
                <h2>Other Services You May Find Valuable</h2>

                <div className="cdsco-regGrid">
                    <Link
                        to="/MedicalDevice/UsFDA"
                        className="cdsco-regCard"
                        aria-label="USA FDA"
                    >
                        <header className="cdsco-regHead">
                            <Flag code="US" className="cdsco-regFlag" title="United States" />
                            <h3>USA FDA</h3>
                        </header>

                        <p>
                            510(k), De Novo, and PMA submissions, labeling/IFU compliance,
                            and robust PMS and vigilance documentation.
                        </p>
                    </Link>

                    <Link
                        to="/MedicalDevice/EU"
                        className="cdsco-regCard"
                        aria-label="EU MDR"
                    >
                        <header className="cdsco-regHead">
                            <Flag code="EU" className="cdsco-regFlag" title="European Union" />
                            <h3>EU MDR</h3>
                        </header>

                        <p>
                            CE-marking support under EU MDR 2017/745, including Technical
                            File, Clinical Evaluation Report, and notified body coordination.
                        </p>
                    </Link>
                </div>
            </section>
        </div>
    );
}